import { RadioGroupItem } from './types';

export const getSelectedItem = <ItemID>(
  items: RadioGroupItem<ItemID>[],
  value: string,
): RadioGroupItem<ItemID> =>
  items.find(({ id }) => id === value || id === Number(value)) ?? items[0];
